import { FC } from 'react';
import Tabs, { Tab, TabList, TabPanel } from '@atlaskit/tabs';

import SolicitacaoHistoricoSecao from 'view/section/SolicitacaoHistoricoSecao/SolicitacaoHistoricoSecao';
import { SolicitacaoComentariosSecao } from 'view/section/SolicitacaoComentariosSecao/SolicitacaoComentariosSecao';

import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { DEVELOPMENT } from 'util/Dev';


interface AtividadesSolicitacaoProps {
  solicitacao: SolicitacaoDetalhada
  loading: boolean
}

export const AtividadesSolicitacao: FC<AtividadesSolicitacaoProps> = ({loading, solicitacao}) => {
  if (loading) {
    return <></>
  }

  return <section>
    <Tabs id="atividades-solicitacao">
      <TabList>
        <Tab>Mensagens</Tab>
        {DEVELOPMENT && <Tab>Histórico</Tab>}
      </TabList>
      <TabPanel>
        <SolicitacaoComentariosSecao solicitacao={solicitacao} />
      </TabPanel>
      {DEVELOPMENT &&
        <TabPanel>
          <SolicitacaoHistoricoSecao />
        </TabPanel>
      }
    </Tabs>
  </section>
}